/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {Col, FormGroup, FormLabel, Row} from "react-bootstrap";
import {UserWithDateTimeFieldViewer} from "../../../Models/Core/FieldViewers/UserWithDateTimeFieldViewer";
import {usePermission} from "../../../Hooks/PermissionHooks";
import {HelpIcon} from "../HelpIcon";
import {SpeciesRequestSourceFieldViewer} from "../../../Models/Core/SpeciesFieldComponents";
import {ContextNodeWithDateTimeFieldViewer} from "../../../Models/Core/FieldViewers/ContextNodeWithDateTimeFieldViewer";


export const SpeciesSummary = (props) => {

	const {species} = props;
	const {SpeciesRequest: speciesRequest = null} = species;
	const permission = usePermission();
	const canSeeLegacyIds = permission("skips_data_segmentation");

	return <div className="sb-summary">
		<Row xs={12}>
			<Col xs={6}>
				{[
					(species?.mobileSampleSpeciesId && canSeeLegacyIds) &&
					<FormGroup key="mobileSampleSpeciesId">
						<FormLabel>SBM Legacy Species ID</FormLabel>
						<div>{species?.mobileSampleSpeciesId}</div>
					</FormGroup>,

					speciesRequest &&
					<FormGroup key="requestedByUserId">
						<FormLabel>Requested By</FormLabel>
						<UserWithDateTimeFieldViewer userId={speciesRequest?.requestedByUserId} date={speciesRequest?.requested} />
					</FormGroup>,

					speciesRequest && <FormGroup key="requesterNotes">
						<FormLabel>Requester Notes</FormLabel>
						<div>{speciesRequest?.requesterNotes ?? '(None Specified)'}</div>
					</FormGroup>,

					speciesRequest &&
					<FormGroup key="observedProjectContextNodeId">
						<FormLabel>Species Observed At</FormLabel>
						<ContextNodeWithDateTimeFieldViewer contextNodeId={speciesRequest?.observedProjectContextNodeId} date={speciesRequest?.observedDate} />
					</FormGroup>,

					!speciesRequest &&
					<FormGroup key="createdByUserId">
						<FormLabel>Created{species?.createdByUserId ? ' By' : null}</FormLabel>
						<UserWithDateTimeFieldViewer userId={species?.createdByUserId} date={species?.created}/>
					</FormGroup>,

					speciesRequest && <FormGroup key="speciesRequestSourceId">
						<FormLabel>Source <HelpIcon>The application or integration from where this Species Request originated.</HelpIcon></FormLabel>
						<SpeciesRequestSourceFieldViewer Value={speciesRequest?.speciesRequestSourceId} />
					</FormGroup>,

				]}
			</Col>
			<Col xs={6}>
				{[
					speciesRequest &&
					<FormGroup key="reviewedByUserId">
						<FormLabel>Last Reviewed By</FormLabel>
						<UserWithDateTimeFieldViewer
							userId={speciesRequest?.reviewedByUserId}
							date={speciesRequest?.reviewed}
							emptyMessage="Not yet reviewed"
						/>
					</FormGroup>,

					speciesRequest &&
					<FormGroup key="reviewerNotes">
						<FormLabel>Reviewer Notes</FormLabel>
						<div>{speciesRequest?.reviewerNotes ?? '(None Specified)'}</div>
					</FormGroup>,

					<FormGroup key="modifiedByUserId">
						<FormLabel>Last Modified{species?.modifiedByUserId ? ' By' : null}</FormLabel>
						<UserWithDateTimeFieldViewer userId={species?.modifiedByUserId} date={species?.modified}/>
					</FormGroup>,
				]}
			</Col>
		</Row>
	</div>;
}
